// Minimal brand SVG icons for music & social platforms.
// Single-color (currentColor) so they tint with the gold theme.
import React from "react";

const base = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  width: "20",
  height: "20",
  "aria-hidden": "true",
};

export const SpotifyIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm5.49 17.32a.75.75 0 0 1-1.03.25c-2.82-1.72-6.37-2.11-10.55-1.16a.75.75 0 1 1-.33-1.46c4.55-1.04 8.46-.59 11.62 1.34.36.22.47.69.29 1.03zm1.47-3.27a.94.94 0 0 1-1.29.31c-3.23-1.99-8.16-2.56-11.99-1.4a.94.94 0 1 1-.55-1.8c4.36-1.32 9.78-.69 13.5 1.6.45.27.59.86.33 1.29zm.13-3.4C15.36 8.4 8.84 8.18 5.27 9.25a1.13 1.13 0 1 1-.65-2.16C8.7 5.83 15.86 6.09 20.2 8.66a1.13 1.13 0 1 1-1.11 1.99z" />
  </svg>
);

export const AppleMusicIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M17.5 4.6c0-.5-.4-.9-.9-.8L9.4 5.3a1 1 0 0 0-.8 1v8.4c-.36-.2-.78-.3-1.22-.3a2.6 2.6 0 1 0 2.62 2.6V8.4l6-1.35V13c-.36-.2-.78-.3-1.22-.3a2.6 2.6 0 1 0 2.62 2.6V4.6z" />
  </svg>
);

export const YouTubeIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z" />
  </svg>
);

export const SoundCloudIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M1.5 14.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3zm2 -1.5a.5.5 0 0 1 1 0v4.5a.5.5 0 0 1-1 0V13zm2 -.7a.5.5 0 0 1 1 0v5.2a.5.5 0 0 1-1 0v-5.2zm2 -1a.5.5 0 0 1 1 0v6.2a.5.5 0 0 1-1 0v-6.2zm2 -.5a.5.5 0 0 1 1 0v6.7a.5.5 0 0 1-1 0v-6.7zM12 8.5c.3 0 .5.2.5.5v9a.5.5 0 0 1-1 0V9c0-.3.2-.5.5-.5zm2.5-.2c.3 0 .5.2.5.5V18a.5.5 0 0 1-1 0V8.8c0-.3.2-.5.5-.5zM17 6.5c2.8 0 5 2 5.4 4.7 1 .3 1.6 1.3 1.6 2.4 0 1.4-1.1 2.5-2.5 2.5H17V6.5z" />
  </svg>
);

export const InstagramIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 2.2c3.2 0 3.6 0 4.85.07 1.17.05 1.8.25 2.23.42.56.22.96.48 1.38.9.42.42.68.82.9 1.38.17.42.37 1.06.42 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.42 2.23-.22.56-.48.96-.9 1.38a3.7 3.7 0 0 1-1.38.9c-.42.17-1.06.37-2.23.42-1.27.06-1.65.07-4.85.07s-3.58 0-4.85-.07c-1.17-.05-1.8-.25-2.23-.42a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.17-.42-.37-1.06-.42-2.23C2.2 15.58 2.2 15.2 2.2 12s.01-3.58.07-4.85c.05-1.17.25-1.8.42-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.17 1.06-.37 2.23-.42C8.42 2.2 8.8 2.2 12 2.2zm0 1.8c-3.15 0-3.52 0-4.76.06-.97.05-1.5.21-1.86.35-.46.18-.79.4-1.14.74-.34.35-.56.68-.74 1.14-.14.35-.3.89-.35 1.86C3.13 8.48 3.12 8.85 3.12 12s0 3.52.06 4.76c.05.97.21 1.5.35 1.86.18.46.4.79.74 1.14.35.34.68.56 1.14.74.35.14.89.3 1.86.35 1.24.06 1.61.06 4.76.06s3.52 0 4.76-.06c.97-.05 1.5-.21 1.86-.35.46-.18.79-.4 1.14-.74.34-.35.56-.68.74-1.14.14-.35.3-.89.35-1.86.06-1.24.06-1.61.06-4.76s0-3.52-.06-4.76c-.05-.97-.21-1.5-.35-1.86a3 3 0 0 0-.74-1.14 3 3 0 0 0-1.14-.74c-.35-.14-.89-.3-1.86-.35C15.52 4 15.15 4 12 4zm0 3.05a4.95 4.95 0 1 1 0 9.9 4.95 4.95 0 0 1 0-9.9zm0 1.8a3.15 3.15 0 1 0 0 6.3 3.15 3.15 0 0 0 0-6.3zm5.15-2.4a1.16 1.16 0 1 1 0 2.32 1.16 1.16 0 0 1 0-2.32z" />
  </svg>
);

export const TikTokIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M19.6 7.3a6.4 6.4 0 0 1-3.7-1.2 6.5 6.5 0 0 1-2.5-3.7h-3.1v12.4a2.7 2.7 0 1 1-2-2.6V8.9a5.8 5.8 0 1 0 5 5.7V9.8a9.6 9.6 0 0 0 6.3 2.3V8.6c-.2 0-.4 0-.6-.1l.6-1.2z" />
  </svg>
);

export const TwitterIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M18.244 2H21l-6.55 7.49L22 22h-6.84l-5.36-7-6.13 7H1.92l7.02-8.02L2 2h6.99l4.85 6.41L18.24 2zm-2.4 18h1.88L8.25 4H6.27l9.57 16z" />
  </svg>
);

export const FacebookIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-7H8v-2.88h2.44V9.84c0-2.42 1.44-3.76 3.64-3.76 1.06 0 2.16.19 2.16.19v2.38h-1.22c-1.2 0-1.58.75-1.58 1.52v1.83h2.68l-.43 2.88h-2.25v7A10 10 0 0 0 22 12z" />
  </svg>
);
